import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Partitions", -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'has-background-black': _ctx.isDark })
    }, _hoisted_2, 2),
    _createElementVNode("div", null, [
      (_ctx.partitions)
        ? (_openBlock(), _createBlock(_component_vue_json_pretty, {
            key: 0,
            data: _ctx.partitions,
            deep: _ctx.expandDepth,
            deepCollapseChildren: _ctx.deepCollapse,
            showLength: true
          }, null, 8, ["data", "deep", "deepCollapseChildren"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}